import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Select,
} from 'antd';
import { withTranslation } from 'react-i18next';

import '@components/FilterForm.scss';
import { SearchOutlined } from '@ant-design/icons';


class FilterForm extends React.Component {
  static propTypes = {
    showPropertyName: PropTypes.bool,
    filteredInfo: PropTypes.shape({
      displayName: PropTypes.string,
      address: PropTypes.address,
      selectedDocumentTypes: PropTypes.array,
    }).isRequired,
    loading: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
  }

  static defaultProps = {
    showPropertyName: false,
    loading: false,
    onSubmit: (filteredInfo) => {},
  }

  constructor(props) {
    super(props);
    this.state = {
      filteredInfo: { ...this.props.filteredInfo },
    };
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.filteredInfo !== this.props.filteredInfo) {
      this.setState({
        filteredInfo: this.props.filteredInfo,
      });
    }
  }

  isDirty() {
    const keys = Object.keys(this.state.filteredInfo);
    return keys.some((key) => this.props.filteredInfo[key] !== this.state.filteredInfo[key]);
  }

  onChangeFilter(key, value) {
    this.setState({
      filteredInfo: {
        ...this.state.filteredInfo,
        [key]: value,
      },
    });
  }

  onSubmit() {
    this.props.onSubmit(this.state.filteredInfo);
  }

  getFormItems() {
    const items = [{
      label: this.props.t("Properties.Property"),
      shouldRender: this.props.showPropertyName,
      span: 6,
      renderChildren: () => (
        <Input
          placeholder={ this.props.t("Properties.PropertyName") }
          onChange={ (e) => this.onChangeFilter('displayName', e.target.value) }
        />
      ),
    }, {
      label: this.props.t("Properties.Address"),
      shouldRender: this.props.showPropertyName,
      span: 6,
      renderChildren: () => (
        <Input
          placeholder={ this.props.t("Properties.PropertyAddress") }
          onChange={ (e) => this.onChangeFilter('address', e.target.value) }
        />
      ),
    }, {
      label: this.props.t("shared.Type"),
      shouldRender: true,
      span: this.props.showPropertyName ? 6 : 16,
      renderChildren: () => (
        <Select
          mode="multiple"
          placeholder={ this.props.t("shared.AllTypes") }
          value={ this.state.filteredInfo.selectedDocumentTypes }
          onChange={ (values) => this.onChangeFilter('selectedDocumentTypes', values) }
        >
          {
            Object.values(this.props.DocumentTypeOptions).sort((a, b) => (a.text.localeCompare(b.text))).map((docTypeOption) => (
              <Select.Option key={ docTypeOption.value } value={ docTypeOption.value }>
                { docTypeOption.text }
              </Select.Option>
            ))
          }
        </Select>
      ),
    }, {
      label: null,
      shouldRender: true,
      span: 6,
      renderChildren: () => (
        <Button
          type="primary"
          icon={<SearchOutlined />}
          disabled={ !this.isDirty() }
          loading={ this.props.loading }
          onClick={ this.onSubmit }
        >
          { this.props.t("actions.Search") }
        </Button>
      ),
    }];
    return items.filter(({ shouldRender }) => { return shouldRender }).map((item, index) => {
      return (
        <Col span={ item.span || 8 } key={ index.toString() }>
          <Form.Item
            label={ item.label }
            labelCol={{ flex: "80px" }}
            wrapperCol={{ flex: "auto" }}
            style={{ marginBottom: 0 }}
          >
            { item.renderChildren() }
          </Form.Item>
        </Col>
      )
    });
  }

  render() {
    return (
      <div style={{ margin: 0, padding: '0 0 10px' }}>
        <Form className="ant-advanced-search-form" layout="horizontal">
          <Row
            gutter={ 24 }
            justify="space-between"
          >
            { this.getFormItems() }
          </Row>
        </Form>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  return {
    DocumentTypeOptions: state.documentsReducer.DocumentTypeOptions,
  };
}

const mapDispatchToProps = (dispatch, props) => {
  return {
  };
}

export default withTranslation('common')(connect(mapStateToProps, mapDispatchToProps)(FilterForm));
